import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSearchParams } from 'react-router-dom';
import localeTranslator from 'library/Hocs/LocalTranslator';
import './style.css';
import EditMainInfo from './tabs/EditMainInfo';
import Users from './tabs/Users';
import JobTitles from './tabs/JobTitles';
import services from 'services';
import { IntegrationConfig, JobTitle, User } from 'constants/resources';
import PrescriptionsConfigurations from './tabs/PrescriptionsConfigurations';
import Integrations from './tabs/Integrations';
import DoctorSchedules from './tabs/DoctorSchedules';
import GuidedToursPanel from 'onboarding/GuidedToursPanel';
var TABS = [
    'emailAndPassword',
    'users',
    'jobTitles',
    'prescriptions',
    'integrations',
    'doctorSchedules',
    'onboarding'
];
var isSettingsTab = function (value) {
    return TABS.includes(value);
};
var Settings = function (_a) {
    var t = _a.translate;
    var permissionService = services.permissionService;
    var params = useSearchParams()[0];
    var requested = params.get('tab');
    var currentTab = isSettingsTab(requested) ? requested : 'emailAndPassword';
    var allowed = (currentTab === 'users' && permissionService.hasPermissionToIndex(User)) ||
        (currentTab === 'jobTitles' && permissionService.hasPermissionToIndex(JobTitle)) ||
        (currentTab === 'prescriptions' && permissionService.hasPermissionToEditMedicalCenterConfig()) ||
        (currentTab === 'integrations' && permissionService.hasPermissionToIndex(IntegrationConfig)) ||
        (currentTab === 'doctorSchedules' && permissionService.hasPermissionToViewDoctorSchedules()) ||
        currentTab === 'emailAndPassword' ||
        currentTab === 'onboarding';
    var tab = allowed ? currentTab : 'emailAndPassword';
    return (_jsxs("div", { className: "set-page", children: [tab !== 'emailAndPassword' && tab !== 'users' && tab !== 'jobTitles' && tab !== 'prescriptions' && tab !== 'integrations' && tab !== 'doctorSchedules' && (_jsxs("header", { className: "set-page__head", children: [_jsx("h1", { children: t("sections.".concat(tab, ".title")) }), _jsx("p", { children: t("sections.".concat(tab, ".subtitle")) })] })), _jsxs("div", { className: "set-page__body", children: [tab === 'emailAndPassword' && _jsx(EditMainInfo, {}), tab === 'users' && _jsx(Users, {}), tab === 'jobTitles' && _jsx(JobTitles, {}), tab === 'prescriptions' && _jsx(PrescriptionsConfigurations, {}), tab === 'integrations' && _jsx(Integrations, {}), tab === 'doctorSchedules' && _jsx(DoctorSchedules, {}), tab === 'onboarding' && _jsx(GuidedToursPanel, {})] })] }));
};
export default localeTranslator(Settings, 'settings');
